<!-- Place this script at the end of the body tag -->

var form = document.getElementById("damage_claim_form");

async function handleSubmit(event) {
    event.preventDefault();
    var status = document.getElementById("damage_claim_form-status");
    var data = new FormData(event.target);
    fetch(event.target.action, {
        method: form.method,
        body: data,
        headers: {
            'Accept': 'application/json'
        }
    }).then(response => {
        if (response.ok) {
            status.innerHTML = "Thanks for contacting us. We'll get back to you as soon as possible.";
            status.classList.add('success');
            form.reset();
            // Hide form after success
            form.style.display = 'none';
        } else {
            response.json().then(data => {
                if (Object.hasOwn(data, 'errors')) {
                    status.innerHTML = data["errors"].map(error => error["message"]).join(", ");
                } else {
                    status.innerHTML = "Oops! There was a problem submitting your form";
                }
                status.classList.add('error');
            })
        }
    }).catch(error => {
        status.innerHTML = "Oops! There was a problem submitting your form";
        status.classList.add('error');
    }).finally(() => {
        // scroll to top smoothly
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

form.addEventListener("submit", handleSubmit)